// frontend/src/pages/ShopProducts.js
import { PhotoProvider, PhotoView } from "react-photo-view";
import "react-photo-view/dist/react-photo-view.css";
import React, { useEffect, useState } from "react";
import axiosInstance from "../api/axiosInstance";
import { useNavigate } from "react-router-dom";
import "./GenericMedicines.css";
import LoadingAnimation from "../components/LoadingAnimation";
import CartButton from "../components/CartButton";
import Swal from "sweetalert2";	
import { Pagination } from "swiper/modules";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";

import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";

export default function GenericMedicines() {
  const navigate = useNavigate();
const [adminPhone, setAdminPhone] = useState("");
  const [products, setProducts] = useState([]);
  const [search, setSearch] = useState("");
  const [pharmacistMsg, setPharmacistMsg] = useState("");
const [suggestions, setSuggestions] = useState([]);
const [showSuggestions, setShowSuggestions] = useState(false);
  const [cartQty, setCartQty] = useState({});
  const [cartItemId, setCartItemId] = useState({});
  const [cartCount, setCartCount] = useState(0);
const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
const [suggestion, setSuggestion] = useState(null);
const [hasMore, setHasMore] = useState(true);

  // 🔥 PER PRODUCT LOADING
  const [updatingId, setUpdatingId] = useState(null);

  const role = localStorage.getItem("userRole");

  // ---------------- LOAD ----------------

  useEffect(() => {
    
    loadCart();
  }, []);

useEffect(() => {
  loadProducts(page, search);
}, [page]);


useEffect(() => {
  const delay = setTimeout(() => {
    setPage(1);
    setHasMore(true);   // 🔥 ADD THIS LINE
    loadProducts(1, search);
  }, 400);

  return () => clearTimeout(delay);
}, [search]);

async function loadProducts(pageNum = page, searchTerm = search) {
  const normalizedSearch = searchTerm
  .replace(/[,+]/g, " ")
  .replace(/\s+/g, " ")
  .trim();
  if (loading) return;

  setLoading(true);

  try {

    const res = await axiosInstance.get(
      `/medicine/list/?page=${pageNum}&search=${encodeURIComponent(normalizedSearch)}&medicine_category=generic`
    );

    const newItems = res.data.results || [];
setHasMore(!!res.data.next);

 setProducts(prev => {

  if (pageNum === 1) {
    setSuggestion(res.data.suggestion);
  }

  if (pageNum === 1) return newItems;

  const unique = newItems.filter(
    item => !prev.some(p => p.id === item.id)
  );

  return [...prev, ...unique];
});

  } catch (err) {

    console.log("Load products error:", err);

  } finally {

    setLoading(false);

  }
}



  async function loadCart() {
    try {
      const res = await axiosInstance.get("/cart/");
      const items = res.data.items || [];
console.log("CART ITEMS:", items);
      const qtyMap = {};
      const idMap = {};

      items.forEach((it) => {
        const pid = `${it.cart_type}_${it.product_id || it.product?.id}`;
console.log("FULL CART ITEM:", it);
console.log(
  "PRODUCT ID:",
  it.product_id,
  "ITEM ID:",
  it.id
);
        if (pid) {
          qtyMap[pid] = it.quantity;
          idMap[pid] = it.id;
        }
      });

      setCartQty(qtyMap);
      setCartItemId(idMap);

      const total = Object.values(qtyMap).reduce((a, b) => a + b, 0);
      setCartCount(total);
  return idMap;
    } catch (err) {
      console.log("Cart error:", err);
      setCartQty({});
      setCartItemId({});
      setCartCount(0);
return {};

    }
  }

  function wait(ms) {
    return new Promise((res) => setTimeout(res, ms));
  }


useEffect(() => {
  if (!search) {
    setSuggestions([]);
    return;
  }

  const delay = setTimeout(async () => {
    try {
const normalizedSearch = search
  .replace(/[,+]/g, " ")
  .replace(/\s+/g, " ")
  .trim();

      const res = await axiosInstance.get(
  `/medicine/suggestions/?q=${encodeURIComponent(normalizedSearch)}&medicine_category=generic`
);

// 🔥 convert simple names → UI format
setSuggestions(res.data);  } catch (err) {
      console.log(err);
    }
  }, 300);

  return () => clearTimeout(delay);
}, [search]);


useEffect(() => {

  const handleScroll = () => {

 if (
  !loading &&
  hasMore &&   // ✅ ADD THIS
  window.innerHeight + document.documentElement.scrollTop
  >= document.documentElement.offsetHeight - 50
) {
  setPage(prev => prev + 1);
}

  };

  window.addEventListener("scroll", handleScroll);

  return () => window.removeEventListener("scroll", handleScroll);

}, [loading, hasMore]);

  // ---------------- ADD ----------------

async function addToCart(productId, quantity = 1) {

  if (updatingId === productId) return;

const product = products.find(p => p.id === productId);

if (!product) return;

const currentQty = cartQty[`medicine_${productId}`] || 0;

if (currentQty + quantity > product.stock) {

  alert(`Only ${product.stock} items available`);

  return;
}





  setUpdatingId(productId);

  // instant UI update
  setCartQty(prev => ({
    ...prev,
    [`medicine_${productId}`]:
(prev[`medicine_${productId}`] || 0) + quantity
  }));

  setCartCount(prev => prev + quantity);

  try {

    const res = await axiosInstance.post("/cart/add/", {
      product_id: productId,
      quantity
    });

    // backend se item id store
    if (res.data?.item_id) {
      const key = `medicine_${productId}`;

setCartItemId(prev => ({
  ...prev,
  [key]: res.data.item_id
}));

await loadCart();
    }

  } catch (err) {

    console.log("Add error:", err);
alert(
  err.response?.data?.error ||
  "Stock limit reached"
);

    // rollback
    setCartQty(prev => ({
  ...prev,
  [`medicine_${productId}`]:
    Math.max(
      0,
      (prev[`medicine_${productId}`] || quantity) - quantity
    )
}));
  } finally {

    setUpdatingId(null);

  }
}



useEffect(() => {
  

  axiosInstance.get("/admin/emergency-contact/get/")
    .then(res => {
     // console.log("Emergency contact data:", res.data); // 👈 yahan
      setAdminPhone(res.data.phone);
    })
    .catch(() => setAdminPhone(""));
}, []);
  // ---------------- INCREASE ----------------

async function increaseQty(productId) {

  if (updatingId === productId) return;
   

const product = products.find(p => p.id === productId);

if (!product) return;

const currentQty = cartQty[`medicine_${productId}`] || 0;

if (currentQty >= product.stock) {

  alert(`Only ${product.stock} items available`);

  return;
}




  setUpdatingId(productId);
const key = `medicine_${productId}`;

let itemId = cartItemId[key];
if (!itemId) {

  const res = await axiosInstance.get("/cart/");
  const items = res.data.items || [];

  const foundItem = items.find(
    (it) =>
      it.cart_type === "medicine" &&
      (it.product_id || it.product?.id) === productId
  );

  itemId = foundItem?.id;
}


console.log(
  "UPDATE PAYLOAD:",
  JSON.stringify({
    productId,
    itemId,
    cart_type: "medicine",
    action: "increase"
  })
);


  // 🔥 UI instantly update
  setCartQty(prev => ({
  ...prev,
  [`medicine_${productId}`]:
    (prev[`medicine_${productId}`] || 0) + 1
}));

  setCartCount(prev => prev + 1);

  try {

    await axiosInstance.post("/cart/update/", {
      item_id: itemId,
      cart_type: "medicine",
      action: "increase",
    });
await loadCart();
  } catch (err) {

  console.log("Increase error:", err);

  // rollback UI
setCartQty(prev => ({
  ...prev,
  [`medicine_${productId}`]:
    Math.max(0, (prev[`medicine_${productId}`] || 1) - 1)
}));

  setCartCount(prev => Math.max(0, prev - 1));

  alert(
    err.response?.data?.error ||
    "Stock limit reached"
  );
} finally {

    setUpdatingId(null);

  }
}

  // ---------------- DECREASE ----------------

async function decreaseQty(productId) {

  if (updatingId === productId) return;

  setUpdatingId(productId);

const key = `medicine_${productId}`;

let itemId = cartItemId[key];

if (!itemId) {

  const res = await axiosInstance.get("/cart/");
  const items = res.data.items || [];

  const foundItem = items.find(
    (it) =>
      it.cart_type === "medicine" &&
      (it.product_id || it.product?.id) === productId
  );

  itemId = foundItem?.id;
}

  const currentQty = cartQty[`medicine_${productId}`] || 0;

  if (currentQty <= 0) return;

  // 🔥 UI instantly update
 setCartQty(prev => ({
  ...prev,
  [`medicine_${productId}`]: currentQty - 1
}));

  setCartCount(prev => Math.max(0, prev - 1));

  try {

    if (currentQty === 1) {

      await axiosInstance.post("/cart/remove/", {
        item_id: itemId,
        cart_type: "medicine",
      });
await loadCart();
    } else {

      await axiosInstance.post("/cart/update/", {
        item_id: itemId,
        cart_type: "medicine",
        action: "decrease",
      });
await loadCart();
    }

  } catch (err) {

    console.log("Decrease error:", err);

  } finally {

    setUpdatingId(null);

  }
}
  // ---------------- MESSAGE ----------------

  async function sendPharmacistMessage() {
    if (!pharmacistMsg.trim()) return;

    try {
      await axiosInstance.post("/request_medicine/", {
        text: pharmacistMsg,
      });

      alert("Sent!");
      setPharmacistMsg("");

    } catch (err) {
      alert("Send failed");
    }
  }

  // ---------------- HELPERS ----------------

  const filteredProducts = Array.isArray(products) ? products : [];



  // ---------------- UI ----------------
if (loading && products.length === 0 && page === 1 && search === "") {
  return <LoadingAnimation />;
}
  return (

    <div className="shop-container">

      {/* HEADER */}



  
  <CartButton />










      {/* SEARCH */}
  <div style={styles.searchWrapper}>


<div
  style={{
    textAlign: "center",
    marginBottom: 18,
    marginTop: 6,
    fontSize: 14,
    color: "#4b5563",
    fontWeight: 500,
    lineHeight: 1.8
  }}
>
  <span style={{ color: "#16a34a", fontWeight: 700 }}>
    ✔
  </span>{" "}
  Same Salt Formula

  <span style={{ margin: "0 10px" }}></span>

  <span style={{ color: "#16a34a", fontWeight: 700 }}>
    ✔
  </span>{" "}
  Trusted Quality

  <span style={{ margin: "0 10px" }}></span>

  <br />

<span style={{ color: "#16a34a", fontWeight: 700 }}>
  ✔
</span>{" "}
Save up to 70%

</div>
      <input

  value={search}

  onChange={(e) => setSearch(e.target.value)}

  onFocus={() => setShowSuggestions(true)}

  onBlur={() =>
      setTimeout(() => setShowSuggestions(false),200)
  }

  placeholder="Search Medicines..."

  style={styles.searchInput}

/>
{suggestion && search.toLowerCase() !== suggestion.toLowerCase() && (
  <div style={{ marginTop: 8, fontSize: 14 }}>
    Did you mean:{" "}

    <span
      style={{ color: "blue", cursor: "pointer", fontWeight: 600 }}
      onClick={() => setSearch(suggestion)}
    >
      {suggestion}
    </span>

  </div>
)}
{showSuggestions && suggestions.length > 0 && (
  <div style={{
    position: "absolute",
    top: "100%",
    left: 0,
    
    width: "100%",
    background: "#fff",
    border: "1px solid #ddd",
    borderRadius: 10,
    
    zIndex: 99999,
    maxHeight:"40vh",
    overflowY: "auto",
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)"
  }}>
    {suggestions.map((item) => (
      <div
        key={item.id}
        style={{ padding: 10, cursor: "pointer" }}
        onClick={() => {
          setSearch(item.name);
          setSuggestions([]);
	  setShowSuggestions(false);
        }}
      >
        <div style={{ fontWeight: 600 }}>{item.name}</div>
        <div style={{ fontSize: 12, color: "#666" }}>
          {item.salt_composition}
        </div>
      </div>
    ))}
  </div>
)}



<div
  style={{
    fontSize: 12,
    color: "#555",
    marginTop: 6,
    textAlign: "center",
    lineHeight: 1.6,
  }}
>
  💊 <b>For best results, search by Salt Name</b>
  <br />
  Example: Paracetamol, Azithromycin, Metformin

</div>



    </div>

      {/* GRID */}

     <div className="product-grid">


        {filteredProducts.map((p) => {

          const qty = cartQty[`medicine_${p.id}`] || 0;
          const isUpdating = updatingId === p.id;

	  const availableStock = p.stock || 0;



          const price = p.selling_price || p.price || 0;
          const mrp = p.mrp || p.price || 0;

          const discount =
            mrp && price ? Math.round(((mrp - price) / mrp) * 100) : 0;

          return (

            <div
  key={p.id}
  style={{
    border: "1px solid #eee",
    padding: 14,
    borderRadius: 10,

    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",

    minHeight: 520,   // IMPORTANT
    background: "#fff"
  }}
>

              <div style={{ textAlign: "center", marginBottom: 6 }}>

{loading && products.length > 0 && (
  <div style={{ textAlign: "center", padding: 10 }}>
    <LoadingAnimation small />
  </div>
)}

  {/* MEDICINE NAME */}







  <div style={{
    fontWeight: 700,
    fontSize: 15,
    color: "#222",
    marginBottom: 4,
    minHeight: 38
  }}>
    {p.name}
  </div>


  {/* SALT BADGE */}

  {p.salt_composition && (

    <div style={{
      display: "inline-block",
      background: "#eef2ff",
      color: "#3730a3",
      padding: "3px 8px",
      borderRadius: 6,
      fontSize: 12,
      fontWeight: 500,
      marginBottom: 3
    }}>

      🧪 {p.salt_composition}

    </div>

  )}


  {/* COMPANY */}

  {p.company && (

    <div style={{
      fontSize: 12,
      color: "#666",
      marginTop: 2
    }}>

      by <span style={{
        fontWeight: 600,
        color: "#111"
      }}>
        {p.company}
      </span>

    </div>

  )}

</div>

              <div
  style={{
    height: 180,
    width: "100%",
    textAlign: "center",
    overflow: "hidden",
    position: "relative",
  }}
>

  {p.images && p.images.length > 0 ? (
<PhotoProvider maskClosable={true}>
    <Swiper
      spaceBetween={0}
      slidesPerView={1}
pagination={{ clickable: true }}
  modules={[Pagination]}
      touchStartPreventDefault={false}
      style={{
        width: "100%",
        height: "100%",
      }}
    >

      {p.images.map((img, index) => (

        <SwiperSlide key={index}>

          <div
            style={{
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              overflow: "hidden",
            }}
          >

          

<PhotoView src={img}>

  <img
    src={img}
    alt={p.name}
    loading="lazy"
    onError={(e) => {
      e.target.src = "/no-image.png";
    }}
    style={{
      width: "100%",
      height: "100%",
      objectFit: "contain",
      cursor: "zoom-in",
    }}
  />

</PhotoView>



          </div>

        </SwiperSlide>

      ))}

    </Swiper>
</PhotoProvider>

  ) : (

  <PhotoProvider maskClosable={true}>

  <PhotoView src={p.image || "/no-image.png"}>

      <img
        src={p.image || "/no-image.png"}
        loading="lazy"
        onError={(e) => {
          e.target.src = "/no-image.png";
        }}
        style={{
          maxWidth: "100%",
          maxHeight: "100%",
          objectFit: "contain",
          cursor: "zoom-in",
        }}
      />

 </PhotoView>
</PhotoProvider>

  )}


</div>

{/* ADD HERE */}

<div
  style={{
    fontSize: 11,
    color: "#777",
    textAlign: "center",
    marginTop: 4,
  }}
>
   <div
  style={{
    fontSize: 11,
    color: "#777",
    textAlign: "center",
    marginTop: 4,
  }}
>
  Tap image to zoom • Tap outside to close
</div>
</div>


          

              <div style={{ textAlign: "center", marginTop: 6 }}>

                <del style={{ color: "red" }}>{mrp ? `₹${mrp}` : ""}</del>
{p.stock === 0 && (

  <div style={{
    color: "red",
    fontWeight: 600,
    marginTop: 4,
    fontSize: 13
  }}>

    Out of Stock

  </div>

)}

                <div style={{ color: "green", fontSize: 18 }}>₹{price}</div>

                {discount > 0 && (
                  <div style={{ color: "orange" }}>{discount}% OFF</div>
                )}

              </div>

              {/* CART */}

              <div style={{ marginTop: 10 }}>

                {qty > 0 ? (

                  <div style={{ textAlign: "center" }}>

                    <div style={{ display: "flex", justifyContent: "center", gap: 10 }}>

                      <button onClick={() => decreaseQty(p.id)} disabled={isUpdating}>
                        −
                      </button>

                      <div>{qty}</div>

                      <button
  onClick={() => increaseQty(p.id)}
  disabled={isUpdating || qty >= availableStock}
>
                        +
                      </button>

                    </div>

                    <button
                      onClick={() => addToCart(p.id, 1)}
                      disabled={isUpdating || qty >= availableStock}
                      style={{
                        width: "100%",
                        marginTop: 10,
                        background:
  qty >= availableStock
    ? "#ccc"
    : "#0284C7",
                        color: "#fff",
                        padding: 8,
                        borderRadius: 6,
                        border: "none",
                      }}
                    >
                      {isUpdating ? (
  <LoadingAnimation small />
) : qty >= availableStock ? (
  "Stock Limit Reached"
) : (
  "Add More"
)}
                    </button>

                  </div>

                ) : (

                  <button
  onClick={() => p.stock > 0 && addToCart(p.id, 1)}
  disabled={p.stock === 0 || isUpdating}
  style={{
    width: "100%",
    marginTop: 10,
    background: p.stock === 0 ? "#ddd" : "green",
    color: p.stock === 0 ? "#666" : "#fff",
    padding: 10,
    borderRadius: 6,
    border: "none",
    fontWeight: 600
  }}
>{isUpdating ? (
  <LoadingAnimation small />
) : p.stock === 0 ? (
  "Out of Stock"
) : (
  "Add to Cart"
)}
</button>

                )}

              </div>

            </div>
          );
        })}

      </div>

{/* MOBILE STICKY CART */}


    </div>

  );
}
const styles = {
searchWrapper: {

  maxWidth: 500,

  margin: "20px auto",
 
  position: "relative", 

},



searchInput: {

  width: "100%",

  padding: 12,

  borderRadius: 10,

  border: "1px solid #ddd",

},
};
